/* eslint-disable @typescript-eslint/naming-convention */
/*
 * Copyright © 2022, Trimble Inc.
 * All rights reserved.
 *
 * The entire contents of this file is protected by U.S. and
 * International Copyright Laws. Unauthorized reproduction,
 * reverse-engineering, and distribution of all or any portion of
 * the code contained in this file is strictly prohibited and may
 * result in severe civil and criminal penalties and will be
 * prosecuted to the maximum extent possible under the law.
 *
 * CONFIDENTIALITY
 *
 * This source code and all resulting intermediate files, as well as the
 * application design, are confidential and proprietary trade secrets of
 * Trimble Inc.
 */

export enum PortalPageName {
  Unspecified = 'Unspecified',
  Ads = 'Ads',
  ItemSearch = 'ItemSearch',
  Downloads = 'Downloads',
  // Estimates = 'Estimates',
  Quotes = 'Quotes',
  Models = 'Models',
  Dashboard = 'Dashboard',
  Alerts = 'Alerts',
}
